import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito tener conocimientos de finanzas para aplicar este método?',
  a: 'No. Reinicia Tus Finanzas fue diseñado para emprendedores, comerciantes y dueños de negocios que buscan resultados prácticos. Todo está explicado paso a paso con ejemplos simples y fáciles de implementar.'
}, {
  q: '¿Este método sirve para cualquier tipo de negocio?',
  a: 'Sí. Las estrategias están enfocadas en organización financiera, control del dinero y planificación, por lo que pueden aplicarse a la mayoría de los emprendimientos, comercios y negocios de servicios.'
}, {
  q: '¿En cuánto tiempo puedo empezar a ver resultados?',
  a: 'Muchos usuarios comienzan a identificar errores financieros y a organizar mejor sus números durante las primeras semanas de implementación. Los resultados dependerán del nivel de aplicación de cada persona.'
}, {
  q: '¿Qué formato tiene el producto?',
  a: 'Todo el contenido se entrega en formato digital. Podrás acceder desde computadora, tablet o celular y avanzar a tu propio ritmo.'
}, {
  q: '¿Qué incluye exactamente la versión de $19.990?',
  a: 'Incluye:\n✅ Las 6 Fases completas.\n✅ Los 6 Bonus Exclusivos.\n❌ No incluye los Bonus Plus Premium.'
}, {
  q: '¿Qué incluye exactamente el KIT PRO de $24.990?',
  a: 'Incluye:\n✅ Las 6 Fases completas.\n✅ Los 6 Bonus Exclusivos.\n✅ Los 3 Bonus Plus Premium.\n✅ Acceso a todos los recursos del sistema.\n\nEs la opción más elegida porque ofrece la experiencia completa por una diferencia mínima de precio.'
}, {
  q: '¿Cuál es la diferencia entre ambos planes?',
  a: 'La diferencia es de solo $5.000 ARS. Con el KIT PRO obtenés los 3 Bonus Plus Premium diseñados para acelerar la organización financiera y ayudarte a generar más oportunidades de crecimiento.'
}, {
  q: '¿Cuándo recibo el producto?',
  a: 'El acceso es inmediato. Una vez confirmada la compra recibirás todo el material digital para comenzar a implementar el método de forma inmediata.'
}, {
  q: '¿Este método me ayudará a ganar más dinero?',
  a: 'El objetivo principal del método es ayudarte a organizar tus finanzas, tomar mejores decisiones y aprovechar mejor los recursos de tu negocio. Muchos emprendedores descubren fugas de dinero, optimizan gastos y mejoran su gestión financiera, pero los resultados específicos dependen de cada caso y de la aplicación del contenido.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-183">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-184">
        <div className="text-center mb-12" data-id="element-185">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-186">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-4" data-id="element-187">
          {faqs.map((faq, index) => <div key={index} className="border border-slate-200 rounded-xl overflow-hidden bg-white" data-id="element-188">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none hover:bg-slate-50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-189">
                <span className="font-bold text-navy-900 pr-4" data-id="element-190">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-191" />
              </button>

              <AnimatePresence data-id="element-192">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-193">
                    <div className="px-6 pb-4 text-slate-600 whitespace-pre-line border-t border-slate-100 pt-4" data-id="element-194">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}